/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

/**
 * Fault codes for generic downstream services errors, should be mapped to 502 HTTP status code.
 * For further information visit https://docs.pagopa.it/gestionedeglierrori/struttura-degli-errori/fault-code.
 */

export type GatewayFault = t.TypeOf<typeof GatewayFault>;
export const GatewayFault = t.string;
